'use es6';

import { fontsLoaded as areFontsLoaded, checkFontsLoaded } from 'foundations-components/utils/fonts';
import { FONTS_TO_LOAD } from 'layout-dnd-components/constants';
export default function debugFontsAndIconsLoaded() {
  const fontsLoaded = areFontsLoaded();
  console.warn('Checking font and icon loading status', JSON.stringify({
    fontsLoaded
  }, null, 2));
  if (!fontsLoaded) {
    checkFontsLoaded(FONTS_TO_LOAD).then(() => console.warn('fontsLoadedPromise resolved')).catch(e => console.warn('fontsLoadedPromise rejected', e));
  }
}